<template>
  <div class='sc-message--file' :style="fileStyle">
    <div class='sc-message--file-name'>
      <icon-file :color="fileStyle.color" />
      <a v-if="data.url"
         :href="data.url"
         target='_blank'
         @click="handleFileDownload"
      >
        {{fileName}}
      </a>
      <span v-else>{{fileName}}</span>
    </div>
  </div>
</template>

<script>
import IconFile from '../icons/icons/IconFile'
import { Event, EventBus } from '@/util/event-bus'

export default {
  components: {
    IconFile
  },

  props: {
    data: {
      type: Object,
      required: true
    },
    messageColors: {
      type: Object,
      required: true
    },
    direction: {
      type: String,
      required: true
    }
  },

  computed: {
    fileName () {
      if (this.data.file) return this.data.file.name

      if (this.data.url) {
        const urlParts = this.data.url.split('/')
        return urlParts[urlParts.length - 1]
      }

      return ''
    },
    fileStyle () {
      const colors = this.direction === 'sent' ? this.messageColors.sentMessage.file : this.messageColors.receivedMessage.file

      return {
        color: colors.text,
        backgroundColor: colors.bg,
        borderColor: colors.border,
        borderStyle: 'solid',
        borderWidth: '1px'
      }
    }
  },

  methods: {
    handleFileDownload () {
      if (this.data.url) {
        const fileExtension = this.data.url.split('.').pop().toLowerCase()
        EventBus.$emit(Event.FILE_OPEN, {
          type: 'file',
          url: this.data.url,
          name: this.fileName,
          extension: fileExtension,
          isOpenable: ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'txt', 'html'].includes(fileExtension)
        })
      }
    }
  }
}
</script>
